import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";
import type { BroadcastSummary } from "../types/broadcasts.types";

function useStatusQuery(status: string): BroadcastSummary[] {
	const [broadcasts, setBroadcasts] = useState<BroadcastSummary[]>([]);

	useEffect(() => {
		const q = query(collection(db, "broadcasts"), where("status", "==", status));
		return onSnapshot(q, (snapshot) => {
			setBroadcasts(
				snapshot.docs.map((doc) => ({
					id: doc.id,
					...(doc.data() as Omit<BroadcastSummary, "id">),
				})),
			);
		});
	}, [status]);

	return broadcasts;
}

export function useActiveBroadcasts() {
	const live = useStatusQuery("live");
	const upcoming = useStatusQuery("upcoming");
	return { live, upcoming };
}
